import $ from 'jquery'

document.addEventListener('turbo:load', () => {
  $('#js-term-modal').modal('show')
})
